import React from 'react'

import './style.scss'
import Skeleton from './skeleton.component'

import { isReactElementOfType } from '../../utils/react'

export default function SkeletonLoader ({
  isLoading = false, // Show loader
  children // content
}) {
  if (isLoading) {
    const skeleton = React
      .Children
      .toArray(children)
      .find(child => isReactElementOfType(child, Skeleton))

    if (!skeleton) {
      return null
    }

    return <>{ skeleton }</>
  }

  return <>{ children.filter(child => !isReactElementOfType(child, Skeleton)) }</>
}

SkeletonLoader.Skeleton =  Skeleton